define.alias("shared/components/shared/ui/blank-panel", "preview-grid/components/shared/ui/blank-panel");